import { z } from 'zod';

const MONEY_PATTERN = /^\d{1,6}(\.\d{1,4})?$/;

const priceField = z.preprocess(
    (v) => (v === null || v === undefined ? '' : v),
    z.string({ invalid_type_error: 'Price is required' })
        .min(1, 'Price is required')
        .regex(MONEY_PATTERN, 'Enter an amount of 0 or more with up to 4 decimal places'),
);

export const addOnSchema = z.object({
    name:             z.string().min(1, 'Name is required').max(255),
    description:      z.string().nullable().optional(),
    category:         z.string().max(255).nullable().optional(),
    vat_category_id:  z.string().uuid('Select a VAT category'),
    price:            priceField,
    // Display-only: derived by useVatDerivedCost and stripped from the output below.
    gross_price:      z.union([z.string(), z.number()]).nullable().optional(),
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
}).transform(({ gross_price: _grossPriceOmit, ...rest }) => rest);

export type AddOnFormValues = z.infer<typeof addOnSchema>;
